<template>
  <button
    type="button"
    class="nup-btn"
    :class="[
      `nup-btn--${variant}`,
      block ? 'nup-btn--block' : '',
      disabled ? 'nup-btn--disabled' : '',
    ]"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot>{{ text }}</slot>
  </button>
</template>

<script lang="ts">
const __sfc_main = {};
__sfc_main.props = {
  text: {
    type: String,
    default: ''
  },
  variant: {
    type: String,
    default: 'orange'
  },
  block: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
};
export default __sfc_main;
</script>

<style scoped>
.nup-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  font-weight: 600;
  color: #fff;
  line-height: 1.2;
  white-space: nowrap;
}

.nup-btn--block {
  width: 100%;
}

.nup-btn--orange {
  height: 106px;
  border-radius: 99px;
  background-image: linear-gradient(90deg, #ff6900 4%, #ff902a 100%);
  border: 1px solid #fff;
  font-size: 40px;
}

.nup-btn--solid {
  height: 88px;
  border-radius: 44px;
  background: #ff6900;
  font-size: 32px;
}

.nup-btn--dark {
  height: 72px;
  padding: 0 32px;
  border-radius: 36px;
  background: #2b2b2b;
  font-size: 28px;
}

.nup-btn--disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
</style>
